import Vue from 'vue'
import VueRouter from 'vue-router'

// const index = r => require.ensure([], () => r(require('../views/index')), 'index');
const index = r => require.ensure([], () => r(require('../views/home/home')), 'index');
const login = r => require.ensure([], () => r(require('../views/user/login')), 'login');
const register = r => require.ensure([], () => r(require('../views/user/register')), 'register');
const news = r => require.ensure([], () => r(require('../views/news/list')), 'news');
const newsInfo = r => require.ensure([], () => r(require('../views/news/info')), 'newsInfo');
const messageCenter = r => require.ensure([], () => r(require('../views/messageList/list')), 'messageCenter');
const applyFor = r => require.ensure([], () => r(require('../views/applyFor/applyFor')), 'applyFor');
const assessIndex = r => require.ensure([], () => r(require('../views/assess/index')), 'assessIndex');
const stepOne = r => require.ensure([], () => r(require('../views/assess/stepOne')), 'stepOne');
const stepTwo = r => require.ensure([], () => r(require('../views/assess/stepTwo')), 'stepTwo');
const criticalTable = r => require.ensure([], () => r(require('../views/assess/criticalTable')), 'criticalTable');
const stepThree = r => require.ensure([], () => r(require('../views/assess/stepThree')), 'stepThree');
const report = r => require.ensure([], () => r(require('../views/assess/report')), 'report');
const reportList = r => require.ensure([], () => r(require('../views/assess/reportList')), 'report');
const digitalizedProducts = r => require.ensure([], () => r(require('../views/assess/digitalizedProducts')), 'digitalizedProducts');
const questionDetail = r => require.ensure([], () => r(require('../views/assess/questionDetail')), 'questionDetail');
const questionList = r => require.ensure([], () => r(require('../views/applyFor/questionList')), 'questionList');
const wx_newsInfo = r => require.ensure([], () => r(require('../views/wx_newsInfo')), 'wx_newsInfo');

Vue.use(VueRouter)

const scrollToTop = () => {
  return {
    x: 0,
    y: 0
  } // 这里表示目标位置为页面左上角
}

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return to.hash ? {
        selector: to.hash
      } : scrollToTop();
    }
  },
  routes: [
    // {
    //     path: '/',
    //     name: 'index',
    //     component: index,
    //     meta: {
    //         title: '汕头市中小企业服务平台-首页'
    //     }
    // },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: '汕头市中小企业数字化转型服务-首页',
        requiresAuth: false
      }
    },
    {
      path: '/',
      redirect: '/index',
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        title: '汕头市中小企业数字化转型服务-登录',
        requiresAuth: false
      }
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        title: '汕头市中小企业数字化转型服务-注册',
        requiresAuth: false
      }
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      meta: {
        title: '汕头市中小企业数字化转型服务-资讯公告',
        requiresAuth: false
      }
    },
    {
      path: '/newsInfo/:id',
      name: 'newsInfo',
      component: newsInfo,
      meta: {
        title: '汕头市中小企业数字化转型服务-资讯公告详情',
        requiresAuth: false
      }
    },
    {
      path: '/messageCenter',
      name: 'messageCenter',
      component: messageCenter,
      meta: {
        title: '汕头市中小企业数字化转型服务-消息中心',
        requiresAuth: true
      }
    },
    {
      path: '/applyFor',
      name: 'applyFor',
      component: applyFor,
      meta: {
        title: '汕头市中小企业数字化转型服务-评测资料上传',
        requiresAuth: true
      }
    },
		{
      path: '/SME/index',
      name: 'assessIndex',
      component: assessIndex,
      meta: {
        title: '汕头市中小企业数字化转型服务-测评首页',
        requiresAuth: false
      }
    },
		{
      path: '/SME/stepOne',
      name: 'stepOne',
      component: stepOne,
      meta: {
        title: '汕头市中小企业数字化转型服务-数字化基础答题',
        requiresAuth: true
      }
    },
    {
      path: '/SME/stepTwo',
      name: 'stepTwo',
      component: stepTwo,
      meta: {
        title: '汕头市中小企业数字化转型服务-选择应用场景',
        requiresAuth: true
      }
    },
    {
      path: '/SME/criticalTable',
      name: 'criticalTable',
      component: criticalTable,
      meta: {
        title: '汕头市中小企业数字化转型服务-数字化经营应用场景等级判定表',
        requiresAuth: false
      }
    },
    {
      path: '/SME/stepThree',
      name: 'stepThree',
      component: stepThree,
      meta: {
        title: '汕头市中小企业数字化转型服务-应用场景答题',
        requiresAuth: true
      }
    },
    {
      path: '/SME/reportList',
      name: 'reportList',
      component: reportList,
      meta: {
        title: '汕头市中小企业数字化转型服务-测评记录',
        requiresAuth: true
      }
    },
    {
      path: '/SME/report/:id',
      name: 'report',
      component: report,
      meta: {
        title: '汕头市中小企业数字化转型服务-测评报告',
        requiresAuth: false
      }
    },
    {
      path: '/SME/digitalizedProducts/:id',
      name: 'digitalizedProducts',
      component: digitalizedProducts,
      meta: {
        title: '汕头市中小企业数字化转型服务-数字化产品',
        requiresAuth: true
      }
    },
    {
      path: '/SME/questionDetail/:id',
      name: 'questionDetail',
      component: questionDetail,
      meta: {
        title: '汕头市中小企业数字化转型服务-做题明细',
        requiresAuth: false
      }
    },
    {
      path: '/applyFor/questionList',
      name: 'questionList',
      component: questionList,
      meta: {
        title: '汕头市中小企业数字化转型服务-佐证材料上传',
        requiresAuth: false
      }
    },
    {
      path: '/wx_newsInfo/:id',
      name: 'wx_newsInfo',
      component: wx_newsInfo,
      meta: {
        title: '汕e企',
        requiresAuth: false
      }
    },
  ],
})
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.requiresAuth) {
    // 1. 检查用户是否已登录（示例：从 cookie 读取 userInfo
    // const isLogin = getCookie('userInfo') !== null
    const isLogin = Boolean(getCookie('userInfo'))
    if (isLogin) {
      // 已登录：允许访问目标页面
      return next()
    } else {
      // 未登录：强制跳转到登录页，并记录当前页面地址（用于登录后回跳）
      
      console.log(to.fullPath);
      
      if(to.fullPath.includes('/SME/stepTwo') || to.fullPath.includes('/SME/stepThree')){
        return next({
          path: '/login',
          query: { redirect: '/SME/stepOne' } // 存储目标页面路径
        })
      }else{
        return next({
          path: '/login',
          query: { redirect: to.fullPath } // 存储目标页面路径
        })
      }
    }
  }else {
    // 无需登录的页面：直接放行
    return next()
  }
});
function getCookie (name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

  if (arr = document.cookie.match(reg))

    return unescape(arr[2]);
  else
    return null;
}

export function createRouter() {
  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js